const inputFileOption = () => {
 const DATA_MAX_SIZE = `file-size`;
 const DATA_FILE_EXTENSION = `file-ext`;

 const validateSize = (fileInput) => {
 const file = fileInput.files[0];

 if (!file) return;

 const maxSize = parseFloat(fileInput.getAttribute(`data-${DATA_MAX_SIZE}`));

 if (file.size / (1024 * 1024) > maxSize) {
 alert(`최대 ${maxSize}MB 까지 첨부 가능합니다.`);
 fileInput.value = ``;
 }
 };

 const validateExtension = (fileInput) => {
 const file = fileInput.files[0];

 if (!file) return;

 const allowedExtensions = fileInput
 .getAttribute(`data-${DATA_FILE_EXTENSION}`)
 .split(`,`)
 .map((ext) => ext.trim().toLowerCase());

 const fileExtension = file.name.split(`.`).pop().toLowerCase();

 if (!allowedExtensions.includes(fileExtension)) {
 alert(`확장자 ${allowedExtensions.join(`, `)} 만 첨부 가능합니다.`);
 fileInput.value = ``;
 }
 };

 const handleInput = ({ target }) => {
 target.matches(`[data-${DATA_MAX_SIZE}]`) && validateSize(target);
 target.matches(`[data-${DATA_FILE_EXTENSION}]`) &&
 validateExtension(target);
 };

 const initialize = () => {
 document.body.addEventListener(`input`, handleInput);
 };

 initialize();

 inputFileOption.cleanup = () => {
 document.body.removeEventListener(`input`, handleInput);
 };
};

export default inputFileOption;
